import React from 'react';
export function Guarantee() {
  return <section className="bg-navy py-12 md:py-24 px-4 text-center text-cream-white" data-id="element-226">
      <div className="max-w-4xl mx-auto" data-id="element-227">
        <span className="text-[64px] mb-8 block" data-id="element-228">🛡️</span>

        <h2 className="font-display font-bold text-cream-white text-[36px] mb-8" data-id="element-229">
          GARANTÍA 7 DÍAS SIN PREGUNTAS
        </h2>

        <div className="space-y-4 text-cream-white/85 font-sans text-lg mb-12" data-id="element-230">
          <p data-id="element-231">Abrís el manual.</p>
          <p data-id="element-232">Lo leés. Lo usás.</p>
          <p data-id="element-233">Si en 7 días no es lo que esperabas:</p>
        </div>

        <p className="font-display font-bold text-gold text-[48px] mb-12" data-id="element-234">
          DEVOLUCIÓN DEL 100%
        </p>

        <div className="flex flex-wrap justify-center items-center gap-6 text-cream-white font-sans mb-12" data-id="element-235">
          <span data-id="element-236">Sin formularios</span>
          <span className="w-1.5 h-1.5 bg-gold rounded-full" data-id="element-237"></span>
          <span data-id="element-238">Sin drama</span>
          <span className="w-1.5 h-1.5 bg-gold rounded-full" data-id="element-239"></span>
          <span data-id="element-240">Sin vueltas</span>
        </div>

        <p className="text-cream-white/60 font-sans font-light italic text-sm" data-id="element-241">
          Tasa de devoluciones: menos del 1%
        </p>
      </div>
    </section>;
}